import type { DemographicInfo } from "./eeo-demographics";
import type { RichTextDoc } from "./rich-text";

const JobApplicationStatuses = {
  Applied: "applied",
  InReview: "in_review",
  Interviewing: "interviewing",
  Offer: "offer",
  Hired: "hired",
  Rejected: "rejected",
} as const;

export const JobApplicationStatusValues = Object.values(JobApplicationStatuses);
export type JobApplicationStatus = (typeof JobApplicationStatuses)[keyof typeof JobApplicationStatuses];

const ApplicationSources = {
  CareersPage: "careers_page",
  Indeed: "indeed",
  LinkedIn: "linkedin",
  BulkImport: "bulk_import",
} as const;

export const ApplicationSourceValues = Object.values(ApplicationSources);
export type ApplicationSource = (typeof ApplicationSources)[keyof typeof ApplicationSources];

const Degrees = {
  GED: "GED",
  HighSchool: "high_school",
  Vocational: "vocational",
  University: "university",
  Other: "other",
} as const;

export const DegreeValues = Object.values(Degrees);
export type DegreeType = (typeof Degrees)[keyof typeof Degrees];

export type CandidateDemographicInfo = DemographicInfo;

export type RejectionReasonHistory = {
  rejection_reason_id: string;
  creator_user_id: string;
  timestamp: number;
};

export type WorkExperience = {
  company_name: string;
  title: string;
  responsibilities: string;
  responsibilities_rich_text?: RichTextDoc | null;
  start_date: string;
  end_date?: string;
  is_current?: boolean;
  location?: string | null;
  reason_for_leaving?: string;
};

export type Education = {
  school_name: string;
  degree: DegreeType;
  degree_or_certificate?: string | null;
  field_of_study: string;
  start_date: string;
  end_date?: string;
  year_completed?: string | null;
  location?: string | null;
};
